module.exports = __webpack_public_path__ + "static/media/41.f43665fe.mp4";